/**
* Create a semaphore.
*
* @param {Number} max - maximum number of locks that can be acquired at any given time
*/
const Semaphore = function(max = 1) {
    var active = 0;
    var resolvers = []; // when locked, each acquire requires a new promise

    /**
     * Returns the number of available locks remaining.
     */
    this.available = () => !(active >= max);

    /**
     * Acquires a lock (just trying).
     * @returns {Boolean} - true if lock was acquired, false otherwise
     */
    this.acquire_try = () => {
        if (active >= max) {
            return false;
        } 
        active += 1;
        return true;
    };

    /**
     * Acquires a lock.
     * @returns {Promise} - promise resolves when a lock has been acquired.
     */
    this.acquire = async () => {
        active += 1;
        if (active <= max) {
            return true;
        }
        var resolver;
        var promise = new Promise(resolve => {
            resolver = resolve;
        });
        resolvers.push(resolver);
        return promise;
    };

    /**
     * Releases a lock so that it is available to be acquired.
     */
    this.release = () => {
        active -= 1;
        if (resolvers.length > 0) {
            resolvers.shift()(true); // let awaiting code run by resolving a promise
        }
    };
};

export default Semaphore;
